export enum SwitchState {
    OFF = 'Off',
    ON = 'On',
}
export enum SwitchEvent{
    STATE_CHANGED = 'onStateChanged'
}